export default __webpack_public_path__ + "static/media/480_business05-es-mobile.d2e1c9cf.png";